export const projects = [
  {
    id: "001",
    industry: "LEGAL",
    name: "Law Firm CRM for 40-Advocate Mumbai Practice",
    metric: "60%",
    metricLabel: "faster client intake",
    year: "2024",
    slug: "/work/law-firm-crm",
  },
  {
    id: "002",
    industry: "REAL ESTATE",
    name: "AI Lead Qualification for Property Broker",
    metric: "3×",
    metricLabel: "more site visits booked",
    year: "2024",
    slug: "/work/real-estate-ai",
  },
  {
    id: "003",
    industry: "HEALTHCARE",
    name: "Patient Management for Multi-Specialty Clinic",
    metric: "0",
    metricLabel: "missed appointments",
    year: "2024",
    slug: "/work/healthcare-patient-management",
  },
  {
    id: "004",
    industry: "E-COMMERCE",
    name: "Shopify D2C Store with AI Recommendations",
    metric: "40%",
    metricLabel: "increase in order value",
    year: "2025",
    slug: "/work/ecommerce",
  },
  {
    id: "005",
    industry: "MANUFACTURING",
    name: "Custom ERP for MSME Auto Parts Manufacturer",
    metric: "₹12L",
    metricLabel: "saved in inventory waste",
    year: "2025",
    slug: "/work/manufacturing-erp",
  },
  {
    id: "006",
    industry: "AI",
    name: "AI Call Centre for Insurance Lead Follow-up",
    metric: "5,000",
    metricLabel: "calls/month, 0 human agents",
    year: "2025",
    slug: "/work/ai-call-centre",
  },
];
